import { queryOptions } from '@tanstack/react-query';
import { axios } from '@/lib/utils/axios';
import type { OrganizationListItemType } from '../../common/organization';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';

export type OrganizationListSuccessResponseType = {
	organizations: OrganizationListItemType[];
};

export type OrganizationsQueryParams = {
	/** Allowlisted `field:asc|desc` pairs, see ORGANIZATION_SORT_FIELDS in the backend DTO. */
	sort?: string;
};

async function getListOrganizations(
	params: OrganizationsQueryParams,
): Promise<OrganizationListSuccessResponseType | null> {
	// Unsorted callers send the same bare request as before sorting existed.
	const response = params.sort
		? await axios.get(`${API_URLS.ORGANIZATIONS.INDEX}`, { params })
		: await axios.get(`${API_URLS.ORGANIZATIONS.INDEX}`);
	return getResponse<OrganizationListSuccessResponseType>(response.data);
}

export function getListOrganizationsOption({
	enabled = true,
	sort,
}: { enabled?: boolean } & OrganizationsQueryParams = {}) {
	return queryOptions({
		// Unsorted callers (pickers, filters) keep sharing ['organizations', 'list']; add/update invalidate
		// ['organizations'], which prefix-matches every sort variant too.
		queryKey: sort ? ['organizations', 'list', { sort }] : ['organizations', 'list'],
		queryFn: () => getListOrganizations({ sort }),
		enabled,
	});
}
